var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"researchLinkRef",staticClass:"research-link-container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.researchLinkContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }